export const TAX_BENEFITS = {
  value: "TAX_BENEFITS",
  key: "clients.client.reports.taxBenefits.title",
};
export const COVERAGE_CERTIFICATE = {
  value: "COVERAGE_CERTIFICATE",
  key: "clients.client.reports.coverageCertificate.title",
};
export const COVERAGE_STATUSES = {
  value: "COVERAGE_STATUSES",
  key: "clients.client.reports.coverageStatuses.title",
};
export const DEPENDENT_PERSON_COVERAGES_TERMINATIONS = {
  value: "DEPENDENT_PERSON_COVERAGES_TERMINATIONS",
  key: "clients.client.reports.dependentPersonCoveragesTerminations.title",
};
export const ENEL_REPORT = {
  value: "ENEL_REPORT",
  key: "clients.client.reports.ENELReport.title",
};
export const PAYROLL_DEDUCTIONS = {
  value: "PAYROLL_DEDUCTIONS",
  key: "clients.client.reports.payrollDeductions.title",
};

export const adminReports = [
  TAX_BENEFITS,
  COVERAGE_CERTIFICATE,
  COVERAGE_STATUSES,
  DEPENDENT_PERSON_COVERAGES_TERMINATIONS,
  ENEL_REPORT,
];

export const nonAdminReports = [PAYROLL_DEDUCTIONS];

export default [...adminReports, ...nonAdminReports];


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/enums/reportTypes.js